import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBankByCode } from "services";
import { Logo } from "app";
import { clearBankerAuth, setBank } from "store";
import Loader from "../layouts/Loader";
import { DateTime } from "luxon";
import { useRouter } from "next/router";

export default function BankValidationWrapper(props: any) {
  const router = useRouter();
  const dispatch = useDispatch();
  const [bankCodeValid, setBankCodeValid] = useState("loading");

  const userToken = useSelector((state: any) => {
    return state.bankerAuth.accessToken;
  });
  const bankerLoginDate = useSelector((state: any) => {
    return state.bankerAuth.loginDate;
  });

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const data: any = await getBankByCode(window.location.host.split(".")[0]);
    if (data) {
      dispatch(setBank(data));
      setBankCodeValid("valid");
    } else {
      setBankCodeValid("invalid");
    }
  };
  const getISTDate = () => {
    // return "13-10-2023"; // Placeholder for the actual date logic
    return DateTime.now().setZone("Asia/Kolkata").toFormat("yyyy-MM-dd");
  };
  const is2FAVerifiedForToday = (verified2faDate: any) => {
    return verified2faDate === getISTDate();
  };
  useEffect(() => {
    if (bankCodeValid !== "valid" || !userToken) {
      return;
    } else if (userToken) {
      const isVerified = is2FAVerifiedForToday(bankerLoginDate);
      if (!isVerified) {
        dispatch(clearBankerAuth());
        if (!router.pathname.includes("validations")) {
          router.replace("/login");
        }
      }
    }
  }, [bankCodeValid, bankerLoginDate, router]);

  if (bankCodeValid === "loading") {
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <Loader height="h-16" width="w-16" color="text-brand-orange" />
      </div>
    );
  }
  if (bankCodeValid === "invalid") {
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <div className="w-full h-screen flex flex-col justify-center items-center">
          <div className="inline-block mb-6 tracking-wider">
            <Logo />
          </div>
          <div className="w-full max-w-sm px-4 py-8 space-y-6 bg-red-100 rounded-md dark:bg-[#12263f]">
            <h1 className="text-xl text-center text-red-800">Invalid Bank</h1>
            <div className="text-center text-red-800">
              You are trying to access the bank which is invalid. Please check
              the url and retry.
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (bankCodeValid === "valid") {
    return props.children;
  }
}
